<template>
    <div>
    </div>
</template>

<script>
    import betSlip from '@/mixins/betSlip'

    export default {
        name: 'BetSlipWorker',
        mixins: [betSlip],
        data() {
            return {
            }
        },
        methods: {
            isJsonString(str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
        },
        },
        watch: {
          '$store.state.updateMatch' (m) {
            if(this.isJsonString(m)){
              this.$getItem('bets', (key, bets) => {
                    //console.log all the kay/value pairs
                    var match = JSON.parse(m)
                    match.forEach( (match,k) => {
                      bets.forEach((obj,objIndex) => {
                          if (obj.eventId == match.id && (match.isSuspended || match.markets.length == 0)) {
                            bets[objIndex].active = false
                            bets[objIndex].odd = 1
                            this.$set(bets, objIndex, bets[objIndex])
                            this.$store.commit("updateBetslip", bets);
                            console.log('asdsad')
                            this.updateBets(bets)
                          }
                      })
                    })
                }, function (err) {
              })
            }
          },
            '$store.state.updateMarket' (m) {
              if(this.isJsonString(m)){
                this.$getItem('bets', (key, bets) => {
                    //console.log all the kay/value pairs
                    var market = JSON.parse(m)
                    market.forEach( (market,k) => {
                      market.selections.forEach( (v,k) => {
                        var objIndex = bets.findIndex(obj => obj.oddId == v.id);
                        if(objIndex >= 0){
                          bets[objIndex].active = !v.isDisabled
                          if(v.value <= 1){
                            this.bets[objIndex].active = false
                          }
                          bets[objIndex].odd = v.value
                          this.$set(bets, objIndex, bets[objIndex])
                          this.$store.commit("updateBetslip", bets);
                          this.updateBets(bets)
                        }
                      })
                    })
                }, function (err) {
                })
              }
            },
        },
        mounted() {
            
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/BetSlipWorker.vue